import React, { useEffect } from 'react';
import dev from '../../images/Capture5.PNG'
import dev3 from '../../images/dev3.PNG'
import dev2 from '../../images/dev2.PNG'
import Aos from 'aos';
import 'aos/dist/aos.css';

const TopDeveloper = () => {
    useEffect(() => {
        Aos.init()
    })
    return (
        <div 
        data-aos="zoom-in"
        data-aos-duration="3000"
        className="bg-gray-300 ">
           <h1 className="text-4xl font-semibold text-red-500">Dental Clinic</h1>
           <div className="grid lg:grid-cols-3 px-5 mt-3">
               <div >
                   <img className="px-3" src={dev} alt="" />
               </div>
               <div>
                   <img className="px-3" src={dev2} alt="" />
               </div>
               <div>
                   <img className="px-3" src={dev3} alt="" />
               </div>
           </div>

           <div className="mt-10">
               
               <p className="text-justify text-xl px-10  mb-5"> AA full-stack single-page Top Developer Hired web app.Users can hire developer and show the price and name.User manage total price. </p>
               
               <button className="px-2 py-1 bg-gray-400 ">React.js</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">React Bootstrap</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">JSX</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Props</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">API</button>
           </div>

           <div className="mt-5 pb-10"> 
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://eloquent-stonebraker-cc4fc4.netlify.app/">Live Preview</a> </button>
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://github.com/Joy10311/Top-Devolopers"> Code Link</a> </button>
           </div>
        </div>
    );
};

export default TopDeveloper;